<template>
  <div class=" seced-page w100">
    <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;"><el-button type="warning" plain
        icon="el-icon-download" @click="exportExcel">导出</el-button></div>

    <div style="margin-bottom: 10px;" class="page_title">
      <span>门票：</span>
    </div>
    <el-table :data="ticket" style="width: 100%" :header-cell-style="styleObj" class="mb20"
      :cell-style="{ fontSize: '15px', color: '#666666' }">
      <el-table-column prop="ruralCreditPay" label="农信支付" ></el-table-column>
      <el-table-column prop="ruralCreditPayRefund" label="农信支付退款"></el-table-column>
      <el-table-column prop="ruralCreditPayRefund" label="农信收入">
        <template #default="scope">
          {{ (scope.row.ruralCreditPay - scope.row.ruralCreditPayRefund).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="offlinePayment" label="线下支付" />
      <el-table-column prop="offlinePaymentRefund" label="线下支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="线下收入">
        <template #default="scope">
          {{ (scope.row.offlinePayment - scope.row.offlinePaymentRefund).toFixed(2) }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="wxPayment" label="微信支付" />
      <el-table-column prop="wxPaymentRefund" label="微信支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="微信收入">
        <template #default="scope">
          {{ (scope.row.wxPayment - scope.row.wxPaymentRefund).toFixed(2) }}
        </template>
      </el-table-column> -->

      <el-table-column prop="dy" label="抖音支付" />
      <el-table-column prop="dyRefund" label="抖音支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="抖音收入">
        <template #default="scope">
          {{ (scope.row.dy - scope.row.dyRefund).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="总金额">
        <template #default="scope">
          {{ getPayment('ticket') }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="退款金额">
        <template #default="scope">
          {{ getRefund('ticket') }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="总收入">
        <template #default="scope">
          {{ getAllPayment('ticket') }}
        </template>
      </el-table-column>

    </el-table>
    <div style="margin-bottom: 10px;" class="page_title">
      <span>年卡：</span>
    </div>
    <el-table :data="yearCard" :header-cell-style="styleObj">
      <el-table-column prop="ruralCreditPay" label="农信支付" ></el-table-column>
      <el-table-column prop="ruralCreditPayRefund" label="农信支付退款"></el-table-column>
      <el-table-column prop="ruralCreditPayRefund" label="农信收入">
        <template #default="scope">
          {{ (scope.row.ruralCreditPay - scope.row.ruralCreditPayRefund).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="offlinePayment" label="线下支付" />
      <el-table-column prop="offlinePaymentRefund" label="线下支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="线下收入">
        <template #default="scope">
          {{ (scope.row.offlinePayment - scope.row.offlinePaymentRefund).toFixed(2) }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="wxPayment" label="微信支付" />
      <el-table-column prop="wxPaymentRefund" label="微信支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="微信收入">
        <template #default="scope">
          {{ (scope.row.wxPayment - scope.row.wxPaymentRefund).toFixed(2) }}
        </template>
      </el-table-column> -->

      <el-table-column prop="dy" label="抖音支付" />
      <el-table-column prop="dyRefund" label="抖音支付退款" />
      <el-table-column prop="ruralCreditPayRefund" label="抖音收入">
        <template #default="scope">
          {{ (scope.row.dy - scope.row.dyRefund).toFixed(2) }}
        </template>
      </el-table-column>



      <el-table-column prop="payment_channel" label="总金额">
        <template #default="scope">
          {{ getPayment('yearCard') }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="退款金额">
        <template #default="scope">
          {{ getRefund('yearCard') }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_channel" label="总收入">
        <template #default="scope">
          {{ getAllPayment('yearCard') }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  props: {
    endTime: {
      default: ''
    },
    startTime: {
      default: ''
    },
  },
  data() {
    return {
      choseArr: [],
      dialogVisible: false,
      styleObj: {
        background: '#F3F3F3',
        color: '#1F3349',
        fontSize: '15px',
        fontWeight: 'normal',
      },
      ticket: [],
      yearCard: []
    }
  },
  methods: {
    exportExcel() {
      if (!this.startTime) return this.$message.error('请选择查询时间')
      if (!this.ticket[0]) return this.$message.error('请搜索后导出')
      let tData = this.ticket[0];
      let yData = this.yearCard[0];
      let t = [{
        '农信支付': tData.ruralCreditPay,
        '农信支付退款': tData.ruralCreditPayRefund,
        '农信收入': (tData.ruralCreditPay - tData.ruralCreditPayRefund).toFixed(2),

        '线下支付': tData.offlinePayment,
        '线下支付退款': tData.offlinePaymentRefund,
        '线下收入': (tData.offlinePayment - tData.offlinePaymentRefund).toFixed(2),

        // '微信支付': tData.wxPayment,
        // '微信支付退款': tData.wxPaymentRefund,
        // '微信收入': (tData.wxPayment - tData.wxPaymentRefund).toFixed(2),

        '抖音支付': tData.dy,
        '抖音支付退款': tData.dyRefund,
        '抖音收入': (tData.dy - tData.dyRefund).toFixed(2),

        '总金额': this.getPayment('ticket'),
        '退款金额': this.getRefund('ticket'),
        '总收入': this.getAllPayment('ticket')
      }]
      let y = [{
        '农信支付': yData.ruralCreditPay,
        '农信支付退款': yData.ruralCreditPayRefund,
        '农信收入': (yData.ruralCreditPay - yData.ruralCreditPayRefund).toFixed(2),
        '线下支付': yData.offlinePayment,
        '线下支付退款': yData.offlinePaymentRefund,
        '线下收入': (yData.offlinePayment - yData.offlinePaymentRefund).toFixed(2),

        // '微信支付': yData.wxPayment,
        // '微信支付退款': yData.wxPaymentRefund,
        // '微信收入': (yData.wxPayment - yData.wxPaymentRefund).toFixed(2),

        '抖音支付': yData.dy,
        '抖音支付退款': yData.dyRefund,
        '抖音收入': (yData.dy - yData.dyRefund).toFixed(2),

        '总金额': this.getPayment('yearCard'),
        '退款金额': this.getRefund('yearCard'),
        '总收入': this.getAllPayment('yearCard')
      }]
      // 创建工作簿
      const wb = XLSX.utils.book_new();
      // 将JSON数据转换为工作表
      const ws = XLSX.utils.json_to_sheet(t);
      const ws1 = XLSX.utils.json_to_sheet(y);
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, '门票');
      XLSX.utils.book_append_sheet(wb, ws1, '年卡');
      // 生成Excel文件并下载
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), (this.startTime + '-' + this.endTime) + '收支报表.xlsx');
    },
    //计算总
    getAllPayment(type) {
      let t = this[type] ? this[type][0] : '';
      if (t) {
        return ((t.ruralCreditPay + t.offlinePayment) - (t.ruralCreditPayRefund +
          t.offlinePaymentRefund)).toFixed(2);
      } else {
        return ''
      }
    },
    //计算收入
    getPayment(type) {
      let t = this[type] ? this[type][0] : '';
      if (t) {
        return (t.ruralCreditPay + t.offlinePayment + t.wxPayment + t.dy).toFixed(2)
      } else {
        return ''
      }
    },
    //计算退款
    getRefund(type) {
      let t = this[type] ? this[type][0] : '';
      if (t) {
        return (t.ruralCreditPayRefund + t.offlinePaymentRefund + t.wxPaymentRefund + t.dyRefund).toFixed(2)
      } else {
        return ''
      }
    },
    resetData() {
      this.api.postUrl('/api/v1/window/statement/income', { startTime: this.startTime, endTime: this.endTime }, { loading: true }).then(res => {
        this.ticket = [res.ticket];
        this.yearCard = [res.yearCard];
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
    clear() {
      this.keyword = '';
      this.list = []
    },
    checkSelectable(row, index) {
      return row.status != '-1';
    },
  },
  created() {
    this.keyword = this.$route.query.search ? this.$route.query.search : ''
  }
}
</script>
<style scoped>
.demo-ruleForm {
  width: 400px;
}
</style>